
import React, { useState, useEffect } from 'react';
import TerviLogo from '../components/common/TerviLogo.jsx';

const AuthLoadingScreen = ({ message = 'Verificando credenciais...' }) => {
    const [show, setShow] = useState(false);

    useEffect(() => {
        // Define um temporizador para só mostrar o loading após 500ms
        const timer = setTimeout(() => {
            setShow(true);
        }, 500);

        // Se o componente for desmontado antes dos 500ms, o temporizador é cancelado
        return () => clearTimeout(timer);
    }, []);

    // Se 'show' for falso, não renderiza nada (evita o "flash")
    if (!show) {
        return null;
    }

    return (
        <div className="fixed inset-0 bg-white bg-opacity-95 z-50 flex flex-col items-center justify-center space-y-6 animate-fade-in">

            {/* Logo em destaque */}
            <TerviLogo size={64} />

            {/* Spinner menor e mais sutil */}
            <div className="w-8 h-8 border-4 border-gray-300 border-t-blue-600 rounded-full animate-spin"></div>

            {/* Mensagem */}
            <p className="text-lg font-semibold text-gray-600">{message}</p>

        </div>
    );
};

// Adicionando a animação de fade-in no seu CSS global ou em um style tag se necessário.
// Por simplicidade, podemos adicionar aqui se não tiver um local para CSS.
// Nota: a melhor prática é colocar isso em um arquivo CSS.
const style = document.createElement('style');
style.innerHTML = `
    @keyframes fadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
    }
    .animate-fade-in {
        animation: fadeIn 0.3s ease-in-out;
    }
`;
document.head.appendChild(style);


export default AuthLoadingScreen;
